import { render } from "./IoRouterLink.vue?vue&type=template&id=6fdb6462&ts=true"
import script from "./IoRouterLink.vue?vue&type=script&lang=ts"
export * from "./IoRouterLink.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__